// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer{margin:0 16px;position:relative;padding-bottom:110px;border-bottom:1px solid hsla(0,0%,100%,.12)}.footer__damik{position:absolute;display:none}.footer__damik--360{right:3.5%;bottom:0;position:absolute}@media (min-width:768px){.footer{padding-bottom:70px}.footer__damik{display:block;right:0;bottom:0;width:38%}.footer__damik--360{display:none}}@media (min-width:1280px){.footer{max-width:949px;margin:0 auto;padding-bottom:66px}.footer__damik{width:43%}}", ""]);
// Exports
module.exports = exports;
